import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3005";
};

export const registerDevice = params => {
  const url = `${baseURL()}/deviceRegister`;

  return axios.post(url, params);
};

export const sendSMS = params => {
  const url = `${baseURL()}/sendSMS`;

  return axios.post(url, params);
};

export const verifySMS = params => {
  const url = `${baseURL()}/verifySMS`;

  return axios.post(url, params);
};

export const login = params => {
  const url = `${baseURL()}/login`;

  return axios.post(url, params);
};

export const logout = params => {
  const url = `${baseURL()}/consumer/logout`;

  return axios.post(url, params);
};

export const relogin = params => {
  const url = `${baseURL()}/relogin`;

  return axios.post(url, params);
};

export const resetPassword = params => {
  const url = `${baseURL()}/resetPass`;

  return axios.post(url, params);
};

export const signUp = params => {
  const url = `${baseURL()}/Signup`;

  return axios.post(url, params);
};

export const getConsumerProfileDetails = () => {
  const url = `${baseURL()}/consumer`;

  return axios.get(url);
};
